export default __webpack_public_path__ + "static/media/profileActive.5bb5eeb0.svg";